// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__nyfMb","tabList":"ProfilePage_tabList__MA-Zi","tabItem":"ProfilePage_tabItem__Pxhld","tabPanel":"ProfilePage_tabPanel__SCYFj"};